import React from 'react';

export default function ThemeDeleteDialog({ theme, onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
      <div className="bg-white rounded shadow p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold">Delete Theme</h3>
        <p className="mt-2">Are you sure you want to delete <strong>{theme?.name}</strong>? This action cannot be undone.</p>
        {theme?.error && <div className="text-red-600 mt-2">{theme.error}</div>}
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onCancel} className="px-3 py-2 bg-gray-200 rounded">Cancel</button>
          <button onClick={onConfirm} className="px-3 py-2 bg-red-600 text-white rounded">Delete</button>
        </div>
      </div>
    </div>
  );
}
